import { LocationConfiguration } from '@/modules/location/domain/LocationConfigurationSchema.ts';

export function isLocationWithWeighingData(location?: LocationConfiguration) {
    if (!location) {
        return false;
    }

    return !!location.driverActions.find(action => action.id === 'weighingData');
}
